import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DocumentTypePort } from '../../../domain/commerce-registry/ports/document-type.port';
import type { DocumentTypeOption } from '../../../domain/commerce-registry/models/commerce-landing.model';
import type { DocumentTypeApiResponse } from '../../../domain/commerce-registry/models/document-type-api.model';
import { ENVIRONMENT } from '../../../../environments/environment';

/** API may send `id` as number; never call string methods on it (avoids runtime throw → empty list). */
function coerceTipoIdentificacionId(raw: unknown): string | undefined {
  if (raw == null) {
    return undefined;
  }
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    return String(Math.trunc(raw));
  }
  const s = String(raw).trim();
  return s.length > 0 ? s : undefined;
}

@Injectable()
export class DocumentTypeApiAdapter extends DocumentTypePort {
  constructor(private readonly http: HttpClient) {
    super();
  }

  loadByCountry(codPais: string): Observable<DocumentTypeOption[]> {
    const base = ENVIRONMENT.apiMobileUrl?.trim();
    if (!base) {
      return of([]);
    }

    const url = `${base.replace(/\/$/, '')}/api/tipo_identificacion?codPais=${encodeURIComponent(codPais)}`;

    return this.http.get<DocumentTypeApiResponse>(url).pipe(
      map((res) =>
        (res?.data ?? [])
          .filter((item) => item.siglas?.trim() && item.tipoDocumento?.trim())
          .map((item) => {
            const idRaw = coerceTipoIdentificacionId(item.id);
            const numericId = idRaw && /^\d+$/.test(idRaw) ? idRaw : undefined;
            // Legacy app uses numeric `id` as option value so mesh (+external_code) matches tipo.
            return {
              code: numericId ?? item.siglas.trim(),
              label: item.tipoDocumento.trim(),
              ...(numericId != null ? { validationTypeId: numericId } : {}),
            };
          }),
      ),
      catchError(() => of([])),
    );
  }
}
